import { PExt } from 'components/myTags/myTags'
import { QRCodeSVG } from 'qrcode.react'
import './blocQr.scss'

type BlocQrProps = {
   txt: string
   url: string
   color: string
   wip?: boolean
}
export default function BlocQr(props: BlocQrProps) {
   const { txt, url, color, wip } = props
   return (
      <div className='flex center zoneQrCode'>
         <div className='cadre flex center'>
            <PExt center fontSize='15px' color={color}>
               {txt}
            </PExt>
         </div>
         {wip ? (
            <PExt center fontSize='15px'>
               En cours de déploiement
            </PExt>
         ) : (
            <QRCodeSVG value={url} fgColor={color} bgColor='none' className='qrcode' size={120} />
         )}
      </div>
   )
}
